import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import mockData from "./mockData";
import "./PopularLocations.css";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const excludedCities = ["Jaipur", "PUSHKAR", "JODHPUR", "Udaipur"];

const PopularLocations = () => {
  const { locations } = mockData;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [selectedCity, setSelectedCity] = useState("");
  const navigate = useNavigate(); // Initialize the navigate hook

  const handleLocationClick = async (location, e) => {
    e.preventDefault();

    if (!excludedCities.includes(location)) {
      setSelectedCity(location);
      setShowPopup(true);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const upperCaseLocation = location.toUpperCase();

      const response = await fetch(
        `${BASE_URL}/api/v1/VendorManagement/show-AllVendorService?ServiceLocations=${upperCaseLocation}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch vendors.");
      }

      const data = await response.json();
      console.log("Fetched Vendors:", data);

      // Navigate to the vendor list page with city data
      navigate(`/vendor-list?ServiceLocations=${location}`, {
        state: { vendors: data },
      });
    } catch (err) {
      console.error("Error fetching vendors:", err);
      setError("Unable to load vendors. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <section id="PopularLocations">
        <div className="container" data-aos="fade-up">
          <div className="row align-items-center">
            <div className="centered-container">
              <h2
                className="section-heading"
                data-aos="zoom-in-down"
                data-aos-delay="100"
                data-aos-duration="900"
              >
                Perfect Places
              </h2>
              <p
                className="section-para text-border"
                data-aos="zoom-in-up"
                data-aos-delay="150"
                data-aos-duration="900"
              >
                "Explore the most enchanting locations for your perfect day."
              </p>
            </div>
          </div>

          <div className="row align-items-center">
            {locations.map((location, index) => (
              <div
                className="col"
                key={index}
                data-aos="fade-up"
                data-aos-delay={(index + 1) * 100}
              >
                <div className="card">
                  <div className="card-img">
                    <Carousel data-bs-theme="dark">
                      {location.images.map((image, i) => (
                        <Carousel.Item key={i}>
                          <img
                            className="d-block w-100"
                            src={image}
                            alt={`${location.name} slide ${i + 1}`}
                          />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  </div>
                  <h3>{location.name}</h3>
                  <div className="card-description">
                    <p>{location.description}</p>
                  </div>
                  <button
                    className="btn-view"
                    onClick={(e) => handleLocationClick(location.name, e)}
                  >
                    View Vendors
                  </button>
                </div>
              </div>
            ))}
          </div>

          {loading && <p>Loading vendors...</p>}
          {error && <p className="error-message">{error}</p>}
        </div>
      </section>

      {/* Popup Modal */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              textAlign: "center",
              width: "90%",
              maxWidth: "400px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
            }}
          >
            <h3>Opening Service Shortly</h3>
            <p
              style={{
                fontSize: "12px",
              }}
            >
              We are working on bringing services to this location. Stay tuned!
            </p>
            <button
              style={{
                backgroundColor: "#007bff",
                color: "white",
                padding: "10px 15px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                marginTop: "10px",
                fontSize: "16px",
              }}
              onClick={() => setShowPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PopularLocations;
